<template>
  <svg :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  class: 'text-body',
})

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-4 w-4 lg:h-5 lg:w-5',
  lg: 'h-6 w-6',
}

const iconClass = computed(() => `${sizeClasses[props.size]} ${props.class}`)
</script>
